import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import type { BondFormTemplate } from "./agent/types";
import { bondFormTemplatesQueryKey } from "./bond-request.keys";

const EMPTY_TEMPLATES: BondFormTemplate[] = [];

export const useFetchBondFormTemplates = () => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();
	const url =
		user.type === "admin"
			? "/v2/admin/surety/bond-forms/templates"
			: "/v2/surety/bond-forms/templates";
	const { data, isLoading } = useQuery({
		queryKey: bondFormTemplatesQueryKey(),
		queryFn: async () => await get<BondFormTemplate[]>(url),
		staleTime: 1000 * 60 * 60 * 24 * 7,
		gcTime: 1000 * 60 * 60 * 24 * 7,
	});

	return {
		bondFormTemplates: data ?? EMPTY_TEMPLATES,
		bondFormTemplatesIsLoading: isLoading,
	};
};
